"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBetween = void 0;
exports.isBetween = (value, min, max) => value > min && value < max;
//# sourceMappingURL=is-between.js.map